<template>
  <b-overlay
    :show="loading"
    variant="white"
    spinner-variant="primary"
  >
    <b-row>
      <b-col>
        <b-card
          :title="$t('foods.foodListDetails')"
        >
          <b-form
            ref="foodlistform"
            @submit.prevent
          >
            <b-row>

              <b-col
                class="mt-2"
                md="6"
                offset-md="3"
              >
                <b-row>

                  <b-col md="12">
                    <b-form-group
                      :label="$t('common.title')"
                      label-for="Title"
                    >

                      <b-form-input
                        id="Title"
                        v-model="getTitle"
                        name="Title"
                        :disabled="true"
                        autocomplete="off"
                      />
                    </b-form-group>

                  </b-col>

                  <b-col md="12">
                    <b-form-group
                      :label="$t('common.diet')"
                      label-for="DietIds"
                    >
                      <z-diet v-model="Form.DietIds" />
                    </b-form-group>
                  </b-col>

                  <b-col md="12">
                    <b-form-group
                      :label="$t('foods.meal')"
                      label-for="FoodMealIds"
                    >
                      <z-food-meal v-model="Form.FoodMealIds" />
                    </b-form-group>
                  </b-col>

                  <b-col md="12">
                    <b-form-group
                      :label="$t('common.description')"
                      label-for="Description"
                    >
                      <b-form-textarea
                        id="Description"
                        v-model="Form.Description"
                        name="Description"
                        rows="5"
                        no-resize
                      />
                    </b-form-group>
                  </b-col>

                  <b-col cols="12">
                    <hr>
                  </b-col>

                  <b-col md="10">
                    <b-form-group
                      class="mt-1"
                      :label="$t('common.food')"
                    />
                  </b-col>

                  <b-col cols="12">

                    <draggable
                      v-model="FoodIds"
                      tag="ul"
                      class="list-group list-group-flush cursor-move"
                    >
                      <b-row
                        v-for="(item, index) in FoodIds"
                        :key="index"
                        tag="li"
                        class="mb-1"
                      >
                        <b-col
                          class="foodlist"
                          md="10"
                        >
                          <b-form-group>
                            <feather-icon
                              class="mr-1"
                              icon="MoreVerticalIcon"
                              size="16"
                            />
                            <z-food
                              v-model="FoodIds[index]"
                              :unselectable="FoodIds"
                              class="w-100"
                            />
                          </b-form-group>
                        </b-col>

                        <b-col
                          md="2"
                          class="mb-1"
                          style="display: flex; align-items: flex-end;"
                        >
                          <div v-if="FoodRemoveId !== index">
                            <b-button
                              v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                              variant="outline-danger"
                              class="btn-icon rounded-circle"
                              @click="removeFood(index)"
                            >
                              <feather-icon
                                icon="TrashIcon"
                              />
                            </b-button>
                          </div>
                          <div v-else>
                            <b-button
                              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                              class="btn-icon rounded-circle"
                              variant="outline-primary"
                              @click="cancelFood"
                            >
                              <feather-icon icon="XIcon" />
                            </b-button>
                            <b-button
                              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                              class="btn-icon rounded-circle ml-1"
                              variant="outline-primary"
                              @click="confirmFood"
                            >
                              <feather-icon icon="CheckIcon" />
                            </b-button>
                          </div>
                        </b-col>
                      </b-row>
                    </draggable>

                  </b-col>

                  <b-col>
                    <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      variant="gradient-info"
                      class="mb-1"
                      @click="addFood"
                    >
                      <feather-icon
                        icon="PlusIcon"
                        class="mr-25"
                      />
                      <span v-text="$t('common.add')" />
                    </b-button>
                  </b-col>

                  <b-col cols="12">
                    <hr>
                  </b-col>

                </b-row>
              </b-col>

              <b-col
                md="10"
                offset-md="1"
              >
                <b-row>

                  <b-col cols="12">
                    <b-row>
                      <b-col md="4">
                        <label v-text="$t('foods.rangeCalorieAndPercent')" style="font-weight: 600; font-size: 1rem;" />
                      </b-col>
                      <b-col md="8">
                        <label v-text="$t('foods.examples')" style="font-weight: 600; font-size: 1rem;" />
                      </b-col>
                    </b-row>
                  </b-col>

                  <b-col
                    v-for="(details, detailsIndex) in Form.FoodListDetails"
                    :key="detailsIndex"
                    cols="12"
                    class="mt-1"
                  >

                    <b-row>
                      <b-col lg="5">
                        <div
                          :ref="'refCalorie' + detailsIndex"
                          class="border rounded"
                        >
                          <b-col cols="12">
                            <b-row>

                              <b-col
                                md="12"
                                class="mt-1"
                              >
                                <b-form-group
                                  label-for="MinCalorie"
                                >
                                  <b-input-group>
                                    <b-input-group-prepend is-text>
                                      {{ $t('foods.fromCalorie') }}
                                    </b-input-group-prepend>
                                    <cleave
                                      v-model="details.MinCalorie"
                                      class="form-control"
                                      :raw="false"
                                      :options="options"
                                    />
                                  </b-input-group>
                                </b-form-group>
                              </b-col>

                              <b-col
                                md="12"
                                class="mt-1"
                              >
                                <b-form-group
                                  label-for="MaxCalorie"
                                >
                                  <b-input-group>
                                    <b-input-group-prepend is-text>
                                      {{ $t('foods.toCalorie') }}
                                    </b-input-group-prepend>
                                    <cleave
                                      v-model="details.MaxCalorie"
                                      class="form-control"
                                      :raw="false"
                                      :options="options"
                                    />
                                  </b-input-group>
                                </b-form-group>
                              </b-col>

                            </b-row>
                          </b-col>
                          <b-col cols="12">
                            <b-row
                              v-for="(item, foodIndex) in details.Food.filter(x => x.Id)"
                              :key="foodIndex"
                              ref="row"
                            >

                              <b-col md="6">
                                <b-form-group>
                                  <z-food
                                    v-model="item.Id"
                                    :disabled="true"
                                  />
                                </b-form-group>
                              </b-col>

                              <b-col md="6">
                                <b-form-group>

                                  <b-input-group>
                                    <b-input-group-prepend is-text>
                                      {{ $t('common.percent') }}
                                    </b-input-group-prepend>
                                    <cleave
                                      v-model="item.Percent"
                                      class="form-control"
                                      :raw="false"
                                      :options="options"
                                    />
                                  </b-input-group>
                                </b-form-group>
                              </b-col>

                            </b-row>

                          </b-col>

                          <b-col>
                            <b-row>
                              <b-col
                                md="7"
                                class="mb-1"
                              >
                                <div v-if="CalorieRemoveId !== detailsIndex">
                                  <b-button
                                    v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                                    variant="outline-danger"
                                    class="btn-icon rounded-circle"
                                    @click="removeCalorie(detailsIndex)"
                                  >
                                    <feather-icon
                                      icon="TrashIcon"
                                    />
                                  </b-button>
                                </div>
                                <div v-else>
                                  <b-button
                                    v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                                    class="btn-icon rounded-circle"
                                    variant="outline-primary"
                                    @click="cancelCalorie"
                                  >
                                    <feather-icon icon="XIcon" />
                                  </b-button>
                                  <b-button
                                    v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                                    class="btn-icon rounded-circle ml-1"
                                    variant="outline-primary"
                                    @click="confirmCalorie"
                                  >
                                    <feather-icon icon="CheckIcon" />
                                  </b-button>
                                </div>
                              </b-col>

                              <b-col
                                md="5"
                                class="mb-1"
                              >
                                <b-button
                                  v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                                  :variant="sumPercent(details) === 100 ? 'outline-success' : 'outline-danger'"
                                  :disabled="sumPercent(details) !== 100"
                                  style="width: 100%;"
                                  @click="convert(detailsIndex)"
                                >
                                  {{ sumPercent(details) }} {{ $t('common.percent') }}
                                </b-button>
                              </b-col>
                            </b-row>
                          </b-col>

                        </div>
                      </b-col>
                      <b-col lg="7">
                        <div
                          class="border rounded"
                          style="height: 100%; overflow-y: auto;"
                          :style="{ 'height': `${details.Height}px` }"
                        >
                          <template v-if="details.Convert && details.Convert.length">
                            <div
                              v-for="(convert, convertIndex) in details.Convert"
                              :key="convertIndex"
                              class="m-1"
                            >
                              <p class="mb-50">
                                {{ $t('foods.calcMeal') }}
                                <span class="text-danger">{{ convert.FoodMeal.Title }}</span> {{ $t('foods.inDiet') }}
                                <span class="text-danger">{{ convert.Diet.Title }}</span> {{ $t('foods.for') }}
                                <span class="text-danger">{{ convert.Calorie }} {{ $t('foods.calorie') }}</span>:
                              </p>
                              <span
                                v-for="(food, index) in convert.Food"
                                :key="index"
                              >
                                <span v-if="index !== 0"> + </span>
                                <b-badge
                                  v-b-tooltip.hover.v-warning
                                  v-b-tooltip.hover.top="$t('foods.equivalent') + food.RealCalorie + $t('foods.calorie')"
                                  variant="light-secondary"
                                >
                                  {{ food.ConsumptionText }} {{ food.Title }}
                                </b-badge>
                              </span>
                              <span> = </span>
                              <span class="font-weight-bolder">{{ convert.Food.reduce(function(accumulator, currentValue) { return accumulator + currentValue.RealCalorie}, 0) }} {{$t('foods.calorie')}}</span>
                            </div>

                          </template>
                        </div>
                      </b-col>
                    </b-row>
                  </b-col>

                  <b-col>
                    <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      variant="gradient-info"
                      class="mb-1 mt-1"
                      @click="addCalorie"
                    >
                      <feather-icon
                        icon="PlusIcon"
                        class="mr-25"
                      />
                      <span v-text="$t('common.add')" />
                    </b-button>
                  </b-col>

                </b-row>

              </b-col>

              <b-col cols="12">
                <hr>
              </b-col>
              <b-col class="mt-1 mb-2 text-center">
                <!--                <b-button-->
                <!--                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"-->
                <!--                    type="submit"-->
                <!--                    variant="primary"-->
                <!--                    class="mr-1"-->
                <!--                    @click="duplicate"-->
                <!--                >-->
                <!--                  کپی-->
                <!--                </b-button>-->
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  type="submit"
                  variant="primary"
                  class="mr-1"
                  @click="save"
                >
                  {{ $t('common.save') }}
                </b-button>
                <b-button
                  v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                  variant="outline-secondary"
                  @click="back"
                >
                  {{ $t('common.back') }}
                </b-button>
              </b-col>

            </b-row>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </b-overlay>
</template>

<script>

import { VBTooltip } from 'bootstrap-vue'
import ZFoodMeal from '@/tools/foodmeal.vue'
import ZFood from '@/tools/food.vue'
import ZDiet from '@/tools/diet.vue'
import { mapState } from 'vuex'
import draggable from 'vuedraggable'

export default {
  name: 'FoodListDetails',
  components: {
    ZFood,
    ZDiet,
    ZFoodMeal,
    draggable,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  data() {
    return {
      Status: [],
      FoodIds: [],
      Form: {
        Id: null,
        Title: null,
        FoodMealIds: [],
        FoodListDetails: [],
        FoodIds: [],
        DietIds: [],
      },
      options: {
        numeral: true,
        numeralThousandsGroupStyle: 'thousand',
        numeralDecimalScale: 4,
      },
      FoodRemoveId: null,
      CalorieRemoveId: null,
      loading: false,
    }
  },
  computed: {
    ...mapState('zirehState', { foods: state => state.foodSelect }),
    getTitle() {
      let title = ''

      if (this.foods && this.foods.length) {
        this.FoodIds.filter(x => x)
          .forEach((item, index) => {
            if (index > 0) {
              title += ' + '
            }
            title += this.foods.filter(x => x.Id === item)[0].Title
          })
      }

      return title
    },
  },
  watch: {
    FoodIds: {
      handler() {
        this.Form.FoodListDetails.forEach(details => {
          const oldFood = details.Food
          this.$set(details, 'Food', [])
          this.FoodIds.forEach(food => {
            const anyFood = oldFood.filter(x => x.Id === food)
            let percent = 0
            if (anyFood.length > 0) {
              percent = anyFood[0].Percent
            }
            details.Food.push({ Id: food, Percent: percent })
          })
        })
        this.setHeight()
      },
      deep: true,
    },
  },
  created() {
    if (this.$route.params.id) {
      this.Form.Id = this.$route.params.id
      this.get()
    } else {
      this.addFood()
    }
  },
  methods: {
    save() {
      let url = this.$api.foodlist.add
      if (this.$route.params.id && this.$route.path.toLowerCase().includes('duplicate') === false) {
        url = this.$api.foodlist.update
      }
      const form = JSON.parse(JSON.stringify(this.Form))
      form.FoodListDetails = form.FoodListDetails.filter(x => parseFloat(x.MaxCalorie.replace(',', '')) > 0)
      form.FoodListDetails.forEach(details => {
        this.$set(details, 'MaxCalorie', details.MaxCalorie.replaceAll(',', ''))
        this.$set(details, 'MinCalorie', details.MinCalorie.replaceAll(',', ''))
        this.$set(details, 'Food', details.Food.filter(x => x.Id))
        details.Food.forEach((item, index) => {
          this.$set(item, 'Sort', index)
        })
      })

      this.loading = true
      this.$http.post(
        url, form,
      )
        .then(() => {
          this.back()
        })
        .finally(() => {
          this.loading = false
        })
    },
    removeCalorie(index) {
      this.CalorieRemoveId = index
    },
    confirmCalorie() {
      this.Form.FoodListDetails.splice(this.CalorieRemoveId, 1)
      this.CalorieRemoveId = null
    },
    cancelCalorie() {
      this.CalorieRemoveId = null
    },
    addCalorie() {
      this.Form.FoodListDetails.push({
        Convert: [], Food: [], MaxCalorie: 0, MinCalorie: 0,
      })
      this.addFood()
      this.removeFood(this.FoodIds.length - 1)
      this.confirmFood()
    },
    get() {
      this.loading = true
      this.$http.post(
        this.$api.foodlist.get, {
          Id: this.Form.Id,
        },
      )
        .then(res => {
          this.loading = false
          this.Form = res.data
          if (this.$route.path.toLowerCase().includes('duplicate')) {
            this.Form.Id = null
          }
          this.FoodIds = res.data.FoodListDetails[0].Food.map(x => x.Id)
          this.Form.FoodListDetails.forEach(details => {
            this.$set(details, 'Convert', [])
          })
        })
    },
    addFood() {
      this.FoodIds.push(null)
    },
    removeFood(index) {
      this.FoodRemoveId = index
    },
    confirmFood() {
      this.FoodIds.splice(this.FoodRemoveId, 1)
      this.FoodRemoveId = null
    },
    cancelFood() {
      this.FoodRemoveId = null
    },
    sumPercent(details) {
      return details.Food.filter(x => x.Id).reduce((accumulator, currentValue) => accumulator + parseFloat(currentValue.Percent), 0)
    },
    setHeight() {
      this.$nextTick(() => {
        this.Form.FoodListDetails.forEach((details, index) => {
          if (this.$refs[`refCalorie${index}`]) {
            const keep = this.Form
            this.$set(details, 'Height', this.$refs[`refCalorie${index}`][0].offsetHeight)
            this.Form = {}
            this.Form = keep
          }
        })
      })
    },
    convert(index) {
      const details = this.Form.FoodListDetails[index]
      const maxCalorie = parseFloat(details.MaxCalorie.replace(',', ''))
      let minCalorie = parseFloat(details.MinCalorie.replace(',', ''))

      /*if (maxCalorie < 1300) {
        this.$bvToast.toast(this.$t('foods.maxCalorieAllow'), {
          title: this.$t('common.errorAction'),
          toaster: 'b-toaster-bottom-right',
          variant: 'danger',
          solid: false,
          appendToast: true,
        })
        return
      }*/

      // if (minCalorie < 1300) {
      //   minCalorie = 1300
      // }

      const averageCalorie = Math.round((minCalorie + maxCalorie) / 2)
      this.$http.post(
        this.$api.foodunit.convert, {
          DietIds: this.Form.DietIds,
          FoodMealIds: this.Form.FoodMealIds,
          Calorie: [minCalorie, averageCalorie, maxCalorie],
          Food: details.Food.filter(x => x.Id),
        },
      )
        .then(res => {
          const keep = this.Form
          this.$set(details, 'Convert', res.data)
          this.Form = {}
          this.Form = keep
        })
    },
  },
}
</script>
